import { AccessLevel } from '#pplx/frontend/components/types/types.js';
/**
 * Access levels that count as an explicit public share, mirroring
 * `AccessLevel.public_access_levels()` in the backend.
 *
 * Legal (2026-08-12): user content may appear in an OG preview only where the
 * user explicitly shared the thread publicly. `ORG_READ`, `COLLECTION_READ` and
 * `SPECIFIC_PEOPLE_READ` are excluded — none is an explicit public share. If
 * that rule changes, change this set and nothing else.
 */
export const EXPLICIT_PUBLIC_SHARE_ACCESS_LEVELS = new Set([
    AccessLevel.PUBLIC_READ,
    AccessLevel.PUBLIC_PUBLISHED,
]);
export const isExplicitPublicShare = (accessLevel) => typeof accessLevel === 'number' && EXPLICIT_PUBLIC_SHARE_ACCESS_LEVELS.has(accessLevel);
export const getThreadAccessLevel = (entity) => entity?.thread_access ?? entity?.access ?? null;
/**
 * Whether an OG preview may contain the user's own words. Fails closed: an
 * unresolvable thread or a missing access level counts as not shared.
 */
export const mayRenderUserContentInOG = (entity) => isExplicitPublicShare(getThreadAccessLevel(entity));
//# sourceMappingURL=ogUserContentAccess.js.map